import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { updateDatasetCancel } from '../actions';
import datasetDiff from '../helper';
import { datasetIsDirty } from '../state/state';

const CancelDatasetAction = ({
  dataset,
  category,
  code,
  isDirty,
  cancelUpdate,
}) => {
  const intl = useIntl();
  const handleOnClick = () => {
    const updates = datasetDiff(dataset);
    const cancel = !isDirty
    || !updates
    || window.confirm(intl.formatMessage({ id: 'dataset.edit.cancel.warning' }));

    if (cancel) {
      cancelUpdate(category, code);
    }
  };

  return (
    <RibbonMenu
      icon="cancel"
      name="cancel"
      message="actions.cancel"
      onClick={handleOnClick}
      className="aridhia-cancel-dataset-action"
    />
  );
};

const mapStateToProps = ({
  datasets: { datasets },
}, { category, code }) => {
  const dataset = findResult(datasets, category, code);
  return {
    dataset,
    isDirty: datasetIsDirty(dataset),
  };
};

const mapDispatchToProps = {
  cancelUpdate: updateDatasetCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelDatasetAction);
